module.exports = __webpack_public_path__ + "static/media/Наумова А.А. (КФА).fcfd237c.pdf";